import { relativeTime } from "./relativeTime";
import dayjs, { Dayjs } from "dayjs";

import { toDayjs } from "./relativeTime";

export default function displayTime(
  time: string | Date | Dayjs | number
): string {
  const timestamp = toDayjs(time);
  const lessThanHourAgo = timestamp.isAfter(dayjs().subtract(1, "hour"));
  const lessThanHourFromNow = timestamp.isBefore(dayjs().add(1, "hour"));
  return lessThanHourAgo && lessThanHourFromNow
    ? relativeTime(timestamp)
    : timestamp.format("h:mm a | MMM D");
}
